import React, { useEffect } from 'react';
import AboutImg from '../assets/images/IMG_0779.JPG';
import AboutImg2 from '../assets/images/IMG_1421.JPG';
import BirndzeImg from '../assets/Team-Partners/Team - Birndze Bete.jpeg';
import NanaImg from '../assets/Team-Partners/Team - Nana Lynn.jpg';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="page-hero">
        <div className="container page-hero__content">
          <h1 className="page-hero__title">About Us</h1>
          <div className="breadcrumb">
            <a href="/">Home</a> <span>/</span> About Us
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="welcome-grid">
            <div>
              <div className="eyebrow">The Problem & The Conviction</div>
              <h2 className="section-title">Rise Locally, Lead Globally</h2>
              <p className="section-body">
                <strong>The problem:</strong> Cameroon's professionals are talented, ambitious and globally competitive - yet massively underrepresented in global networks, platforms and opportunities.
              </p>
              <p className="section-body" style={{fontSize: 18, fontStyle: 'italic', fontWeight: 600, color: 'var(--blue)', borderLeft: '4px solid var(--red)', paddingLeft: 16, margin: '24px 0'}}>
                "Cameroon does not lack talent. It lacks the platform that makes that talent visible to the world. We build that platform."
              </p>
              <p className="section-body">
                <strong>The conviction:</strong> A team of Cameroonian professionals decided to build the platform that did not exist: a national community to connect, equip and elevate Cameroonian talent.
              </p>
            </div>
            <div className="welcome-img-wrap" style={{boxShadow: 'var(--shadow-lg)'}}>
              <img src={AboutImg} alt="About LLC" style={{ objectPosition: 'center 10%' }} />
            </div>
          </div>
        </div>
      </section>




      {/* DEMOGRAPHICS */}
      <section className="section section--gray">
        <div className="container">
          <div className="text-center mb-12">
            <div className="eyebrow" style={{justifyContent: 'center'}}>The Opportunity</div>
            <h2 className="section-title">Who Attends LLC 2026?</h2>
            <p className="section-body">A deliberately curated audience - the most commercially valuable professional demographic in Cameroon.</p>
          </div>
          
          <div className="who-attends-grid">
            {/* Card 1: Audience Breakdown */}
            <div className="who-attends-card">
              <div>
                <h3 style={{fontFamily: 'Montserrat', fontSize: 20, fontWeight: 800, color: 'var(--text-dark)', marginBottom: 24}}>Audience Breakdown</h3>
                
                <div className="progress-bar-group">
                  <div className="progress-bar-header">
                    <span className="progress-bar-title">Corporate Professionals</span>
                    <span className="progress-bar-percent">35%</span>
                  </div>
                  <div className="progress-bar-track">
                    <div className="progress-bar-fill" style={{width: '35%', background: 'var(--blue)'}}></div>
                  </div>
                  <p className="progress-bar-desc">Employees at SMEs, multinationals and public sector organizations</p>
                </div>

                <div className="progress-bar-group">
                  <div className="progress-bar-header">
                    <span className="progress-bar-title">Entrepreneurs & Founders</span>
                    <span className="progress-bar-percent">25%</span>
                  </div>
                  <div className="progress-bar-track">
                    <div className="progress-bar-fill" style={{width: '25%', background: 'var(--blue-dark)'}}></div>
                  </div>
                  <p className="progress-bar-desc">Active business owners, startup founders and freelancers</p>
                </div>

                <div className="progress-bar-group">
                  <div className="progress-bar-header">
                    <span className="progress-bar-title">Students & Graduates</span>
                    <span className="progress-bar-percent">25%</span>
                  </div>
                  <div className="progress-bar-track">
                    <div className="progress-bar-fill" style={{width: '25%', background: 'var(--green)'}}></div>
                  </div>
                  <p className="progress-bar-desc">University students and recent graduates entering the workforce</p>
                </div>

                <div className="progress-bar-group">
                  <div className="progress-bar-header">
                    <span className="progress-bar-title">Diaspora & Internationals</span>
                    <span className="progress-bar-percent">15%</span>
                  </div>
                  <div className="progress-bar-track">
                    <div className="progress-bar-fill" style={{width: '15%', background: 'var(--yellow)'}}></div>
                  </div>
                  <p className="progress-bar-desc">Cameroonian diaspora and international professionals</p>
                </div>
              </div>
            </div>

            {/* Card 2: Cameroon Talent */}
            <div className="who-attends-card who-attends-card--gradient">
              <div>
                <h3 style={{fontFamily: 'Montserrat', fontSize: 20, fontWeight: 800, color: '#fff', marginBottom: 6}}>Cameroon Talent</h3>
                <p style={{fontSize: 13, color: 'rgba(255, 255, 255, 0.7)', marginBottom: 28}}>The opportunity we are investing in</p>
                
                <div className="demographics-metric-grid">
                  <div className="demographics-metric-item">
                    <div className="demographics-metric-num">#1</div>
                    <div className="demographics-metric-label">French-speaking Africa market</div>
                  </div>
                  <div className="demographics-metric-item">
                    <div className="demographics-metric-num">18</div>
                    <div className="demographics-metric-label">Median age (youngest workforce)</div>
                  </div>
                  <div className="demographics-metric-item">
                    <div className="demographics-metric-num">60%</div>
                    <div className="demographics-metric-label">Under 25 entering workforce</div>
                  </div>
                  <div className="demographics-metric-item">
                    <div className="demographics-metric-num">26M</div>
                    <div className="demographics-metric-label">Total Population</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3: Photo Overlay Card */}
            <div className="who-attends-card who-attends-card--photo">
              <img src={AboutImg2} alt="Students at LLC" className="who-attends-photo-bg" />
              <div className="who-attends-photo-overlay">
                <span className="who-attends-overlay-tag">LLC 2026 Summit</span>
                <h3 className="who-attends-overlay-title">Connect, Equip, Elevate</h3>
                <p className="who-attends-overlay-desc">
                  Building the bridges to position Cameroon's most talented minds for the world stage.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section className="section">
        <div className="container text-center">
          <div className="eyebrow" style={{justifyContent: 'center'}}>The Team</div>
          <h2 className="section-title">The People Behind LLC 2026</h2>
          <p className="section-body" style={{maxWidth: 660, margin: '0 auto 16px'}}>
            A team of 3 Conveners, 8 Directors, a Board of Advisors and 40+ volunteers — all Cameroonian professionals committed to building this country's most important platform.
          </p>
          
          {/* CONVENERS */}
          <div className="team-section-group">
            <div className="team-section-group__title" style={{justifyContent: 'center'}}>Conveners</div>
            <div className="speakers-grid" style={{ marginTop: '24px', justifyContent: 'center' }}>
              {[
                { name: 'Nana Lynn', role: 'Convener & Project Lead', image: NanaImg, initials: 'NL' },
                { name: 'Birndze Bete', role: 'Convener & Operations Lead', image: BirndzeImg, initials: 'BB' },
                { name: 'Mah Ekonde', role: 'Convener & Engagement Lead', image: null, initials: 'ME' },
              ].map((member, idx) => (
                <div className="speaker-card" key={idx} style={{ textAlign: 'left' }}>
                  {member.image ? (
                    <img src={member.image} alt={member.name} className="speaker-card__photo" style={{ objectFit: 'cover', objectPosition: 'top', height: '320px', width: '100%' }} />
                  ) : (
                    <div className="speaker-card__photo-placeholder" style={{ height: '320px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, var(--blue-light), #d0e8f7)', color: 'var(--blue)', fontSize: '36px', fontWeight: '800', fontFamily: 'Montserrat, sans-serif' }}>
                      {member.initials}
                    </div>
                  )}
                  <div className="speaker-card__info" style={{ padding: '20px' }}>
                    <h3 className="speaker-card__name" style={{ fontSize: '17px', fontWeight: '800', color: 'var(--text-dark)' }}>{member.name}</h3>
                    <div className="speaker-card__role" style={{ fontSize: '13px', color: 'var(--red)', fontWeight: '600', marginTop: '4px' }}>{member.role}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* BOARD OF DIRECTORS */}
          <div className="team-section-group">
            <div className="team-section-group__title" style={{justifyContent: 'center'}}>Board of Directors</div>
            <div className="team-grid-compact">
              {[
                { name: 'Gaetan Njijam', role: 'Director, Event Quality Assurance', initials: 'GN' },
                { name: 'Fon Clotilde', role: 'Director, Volunteers & Speaker Management', initials: 'FC' },
                { name: 'Britney Fonki', role: 'Director, Corporate Communications', initials: 'BF' },
                { name: 'Cecilia Balemba', role: 'Director, Creative Specialist', initials: 'CB' },
                { name: 'Onize Ndichia', role: 'Director, Social Media Management', initials: 'ON' },
                { name: 'Mbi Valid', role: 'Director, Membership', initials: 'MV' },
                { name: 'Atem Synderline', role: 'Director, Finance', initials: 'AS' },
                { name: 'TBA', role: 'Director, Strategic Partnerships', initials: 'SP' },
              ].map((member, idx) => (
                <div className="team-member-compact" key={idx}>
                  <div className="team-member-compact__initials">{member.initials}</div>
                  <div className="team-member-compact__name">{member.name}</div>
                  <div className="team-member-compact__role">{member.role}</div>
                </div>
              ))}
            </div>
          </div>

          {/* BOARD OF ADVISORS */}
          <div className="team-section-group">
            <div className="team-section-group__title" style={{justifyContent: 'center'}}>Board of Advisors</div>
            <div className="team-grid-compact" style={{ maxWidth: 450, margin: '0 auto' }}>
              {[
                { name: 'Dr. Beckely Ehah', role: 'Advisor', initials: 'BE' },
                { name: 'Felix Fomengia', role: 'Advisor', initials: 'FF' },
              ].map((member, idx) => (
                <div className="team-member-compact" key={idx}>
                  <div className="team-member-compact__initials">{member.initials}</div>
                  <div className="team-member-compact__name">{member.name}</div>
                  <div className="team-member-compact__role">{member.role}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default About;
